module.exports = __webpack_public_path__ + "img/garbage-popin.b17eca0c.svg";